import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'

/**
 * Height below which the sidebar drops its labels and shows icons only,
 * whatever the user's expand/collapse choice. Chosen so the five main links,
 * the four secondary links and the logo still fit without scrolling: 9 rows ×
 * 35px + logo + padding ≈ 420px, leaving room for the header chrome above.
 */
export const SIDEBAR_ICONS_ONLY_HEIGHT = 560

/**
 * useSidebarFit — how much sidebar fits in this viewport.
 *
 * Note what is NOT here: a "should it scroll" threshold. The middle region is
 * `flex-1 min-h-0 overflow-y-auto`, so the browser scrolls it exactly when the
 * content doesn't fit and leaves it alone when it does. A JS breakpoint for
 * that would only be a worse copy of what the layout already knows.
 */
export function useSidebarFit () {
  const { height } = useWindowSize()

  return {
    height,
    /** Too short for labels — collapse to icons so nav stays reachable. */
    forceIconsOnly: computed(() => height.value < SIDEBAR_ICONS_ONLY_HEIGHT),
  }
}
